<template>
  <el-container style="height: 100vh">
    <!-- 侧边栏 -->
    <el-aside :width="collapsed ? '64px' : '220px'" style="background-color: #304156; transition: width 0.3s">
      <div class="logo" style="height: 60px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 18px; font-weight: bold; border-bottom: 1px solid rgba(255,255,255,0.1)">
        <span v-if="!collapsed">博思博喻</span>
        <span v-else style="font-size: 14px">后台</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        :collapse="collapsed"
        router
        style="border-right: none"
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">工作台</span>
        </el-menu-item>
        <el-menu-item index="/users">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item index="/certifications">
          <i class="el-icon-s-check"></i>
          <span slot="title">认证管理</span>
        </el-menu-item>
        <el-menu-item index="/cities">
          <i class="el-icon-map-location"></i>
          <span slot="title">城市管理</span>
        </el-menu-item>
        <el-menu-item index="/categories">
          <i class="el-icon-s-grid"></i>
          <span slot="title">分类管理</span>
        </el-menu-item>
        <el-menu-item index="/posts">
          <i class="el-icon-document"></i>
          <span slot="title">帖子管理</span>
        </el-menu-item>
        <el-menu-item index="/violation-words">
          <i class="el-icon-warning-outline"></i>
          <span slot="title">违规词库</span>
        </el-menu-item>
        <el-menu-item index="/fee-rules">
          <i class="el-icon-money"></i>
          <span slot="title">收费规则</span>
        </el-menu-item>
        <el-menu-item index="/revenue">
          <i class="el-icon-s-data"></i>
          <span slot="title">收入统计</span>
        </el-menu-item>
        <el-menu-item index="/reports">
          <i class="el-icon-warning"></i>
          <span slot="title">举报管理</span>
        </el-menu-item>
        <el-menu-item index="/banners">
          <i class="el-icon-picture-outline"></i>
          <span slot="title">广告管理</span>
        </el-menu-item>
        <el-menu-item index="/hot-search">
          <i class="el-icon-search"></i>
          <span slot="title">热搜词管理</span>
        </el-menu-item>
        <el-menu-item index="/system">
          <i class="el-icon-setting"></i>
          <span slot="title">系统配置</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶栏 -->
      <el-header style="background: #fff; border-bottom: 1px solid #e6e6e6; display: flex; align-items: center; justify-content: space-between; padding: 0 20px; height: 60px">
        <div style="display: flex; align-items: center">
          <i
            :class="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            style="font-size: 20px; cursor: pointer; margin-right: 20px"
            @click="collapsed = !collapsed"
          ></i>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/dashboard' }">博思博喻</el-breadcrumb-item>
            <el-breadcrumb-item v-if="pageTitle">{{ pageTitle }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div style="display: flex; align-items: center">
          <el-dropdown @command="handleCommand">
            <span style="cursor: pointer; display: flex; align-items: center">
              <i class="el-icon-user-solid" style="margin-right: 5px"></i>
              {{ userInfo.nickname || userInfo.username || '管理员' }}
              <i class="el-icon-arrow-down" style="margin-left: 5px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人信息</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main style="background: #f0f2f5; padding: 20px">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Layout',
  data() {
    return {
      collapsed: false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    pageTitle() {
      return this.$route.meta && this.$route.meta.title
    },
    activeMenu() {
      const route = this.$route
      return route.path
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    ...mapActions(['getInfo', 'logout']),
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' }).then(() => {
          this.logout().then(() => {
            this.$router.push('/login')
            this.$message.success('已退出登录')
          })
        }).catch(() => {})
      } else if (command === 'profile') {
        this.$message.info('个人信息功能开发中')
      }
    }
  }
}
</script>
